import ActionMediaContainer from './ActionMediaContainer';

export default ActionMediaContainer;
